import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { AllocatedBalance, CreateAllocatedBalance } from 'src/app/models/balance';
import { CedenteContrato } from 'src/app/models/cedente-contrato';
import { CentroCusto } from 'src/app/models/centro-custo';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BalanceService } from 'src/app/services/balance.service';
import { CentroCustoService } from 'src/app/services/centro-custo.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';

@Component({
  selector: 'app-saldo-alocado-edit',
  templateUrl: './saldo-alocado-edit.component.html',
  styleUrls: ['./saldo-alocado-edit.component.css']
})
export class SaldoAlocadoEditComponent implements OnInit {

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private modalService: NgbModal,
        private formBuilder: FormBuilder,
        private alertService: NewAlertService,
        private balanceService: BalanceService,
        private contratoService: ContratoService,
        private centroCustoService: CentroCustoService,
        private authenticationService: AuthenticationService,
    ) { }

    public currentUser: Auth;
    public produtosList: CedenteContrato[];
    public centrosCustosList: CentroCusto[];
    public id: number;
    public allocatedBalance: AllocatedBalance;
    public createAllocatedBalance: CreateAllocatedBalance;
    public loaded: boolean = false;
    public otherProductsRequired: boolean = false;

    public allocatedBalanceFormGroup: FormGroup;

    public get form() {
        return this.allocatedBalanceFormGroup.controls;
    }

    ngOnInit(): void {
        this.currentUser = this.authenticationService.currentUserValue;

        this.carregarLista();

        this.route.paramMap.subscribe(params => {
        this.id = +params.get('id');
        });

        this.carregarSaldo();
    }

    carregarSaldo() {
        this.balanceService.getAllocatedBalance(this.id, this.currentUser.token.assignorGuid).subscribe(
        response => {
            if (response.status === ApiError.Sucesso) {
            this.allocatedBalance = response.result;

            let products = []
            let productsPrincipal;
            this.allocatedBalance?.products?.forEach(p => {
                if (!p.isPrincipal)
                products.push(p.productId);
                else
                productsPrincipal = p.productId
            })
            this.createForm(
                response.result.name,
                response.result.costCenterId,
                productsPrincipal,
                products
            );
            this.loaded = true;

            }
            else {
            this.alertService.error(response.message);
            }
        }, error => { console.log(error.message) }
        );
    }

    createForm(nome: string, costCenterId: number, principalProductId: number, products: number[]) {
        this.allocatedBalanceFormGroup = this.formBuilder.group({
        name: new FormControl(nome, [
            Validators.required,
            Validators.maxLength(100)
        ]),
        costCenterId: new FormControl(costCenterId, []),
        principalProductId: new FormControl(principalProductId, [
            Validators.required,
        ]),
        products: new FormControl(products, [])
        });

    }

    carregarLista() {
        this.contratoService.getAll(this.currentUser.token.assignorGuid).subscribe(
        response => {
            this.produtosList = response.result;
            this.changeValidation();
        });

        this.centroCustoService.getAll(this.currentUser.token.assignorGuid).subscribe(
        response => {
            this.centrosCustosList = response.result;
        });
    }

    onSubmit(allocatedBalance: CreateAllocatedBalance) {
        if (this.allocatedBalanceFormGroup.valid) {
        allocatedBalance.assignorGuid = this.currentUser.token.assignorGuid
        allocatedBalance.allocatedBalanceId = this.id;
        allocatedBalance.products = [];
        this.balanceService.updateAllocatedBalance(this.currentUser.token.assignorGuid, allocatedBalance).subscribe(
            response => {
            if (response.status === ApiError.Sucesso) {
                this.alertService.success(response.message, true);
                this.navigateToList();
            } else {
                this.alertService.error(response.message);
            }
            },
            error => {
            this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
            }
        );
        } else {
        GenericValidator.verifierValidatorsForm(this.allocatedBalanceFormGroup);
        }
    }

    changeValidation(){

        const productCategory = this.produtosList.find(x=> x.produtoElegibilidade.produto.produtoId === this.allocatedBalance.products.find(y=>y.isPrincipal).productId).produtoElegibilidade.produto.produtoCategoria;

        if(productCategory == 7){
            this.allocatedBalanceFormGroup.controls.products.setValidators([Validators.required]);
            this.otherProductsRequired = true;
        }
        else{
            this.allocatedBalanceFormGroup.controls.products.clearValidators();
            this.otherProductsRequired = false;
        }

        this.allocatedBalanceFormGroup.controls.products.updateValueAndValidity();

    }

    navigateToList(){
        this.router.navigate(['list'], { relativeTo: this.route.parent });
    }

}

